/**
 * Validates a post-login return target that arrived in the URL.
 *
 * Only a same-origin path is ever honoured: it must start with a single `/`,
 * so `//evil.example`, `https://...`, `javascript:` and backslash variants are
 * all rejected. Anything else yields `null`, and callers fall back to the
 * dashboard. Keeping this a pure function means the rule is tested once and
 * shared by every page that reads a `redirect` parameter.
 */
export function sanitizeInternalPath(value: string | null | undefined): string | null {
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > 2048) return null;
  if (!trimmed.startsWith("/")) return null;
  if (trimmed.startsWith("//") || trimmed.startsWith("/\\")) return null;
  // Control characters (Unicode category Cc) and whitespace can smuggle a
  // scheme past naive checks.
  if (/[\p{Cc}\s]/u.test(trimmed)) return null;

  return trimmed;
}
